module.exports = __webpack_public_path__ + "static/media/image-9.115d1553.avif";